import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  navHeight: 56,
  sectionPadding: "padding-top: 1.5em; padding-bottom: 1.5em;",
  fonts: {
    primary: "Whyte Inktrap, sans-serif",
    secondary: "Inter, sans-serif",
  },
  layout: {
    contentWidth: 1236,
  },
  palette: {
    primary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#0E1014",
      light: "#F4F4F4",
      dark: "#000000",
    },
    secondary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#261003",
      light: "#1F1D2F",
      dark: "#1F1D2F",
    },
    tertiary: {
      main: "#2C9ED0",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#F26B2A",
      content: "#000000",
      tertiary: "#989898",
      disabled: "#10355A",
      hint: "#10355A",
      light: "#FFFFFF",
    },
    alternate: {
      main: "rgb(247, 249, 250)",
      dark: "#e8eaf6",
    },
  },
  typography: {
    fontFamily: `"Whyte Inktrap", "Inter", "Arial", sans-serif`,
  },
})

export default theme
